import React, { useEffect, useRef, useState, memo } from 'react';
import FooterSection from "../Components/FooterSection";
import Header from '../Components/Header';
import PageTitleSection from "../Components/PageTitleSection";
import HttpHelper from '../service/httpService'
import { handleImageError } from 'base/Utility'

import { toDataSourceRequestString, translateDataSourceResultGroups, filterBy } from '@progress/kendo-data-query';
import { Pager } from "@progress/kendo-react-data-tools";

const TrailbossBurner = () => {

    const [dataState, setDataState] = useState({
        skip: 0, take: 10
    });
    const [total, setTotal] = useState(0);

    const [newsLetter, setNewsLetter] = useState({});

    const getNewsLetter = async (data) => {

        const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state.
        await HttpHelper.get("Website/NewsLetter?" + queryStr, data).then((response) => {
            setNewsLetter(response.data.data);
            setTotal(response.data.total);
        });
    }

    //Sandeep: Download and save pdf
    const saveNewsLetter = async (e, id, isMigrated) => {
        if (isMigrated) {
            e.preventDefault();
            await HttpHelper.get("Website/SaveNewsLetter/" + id).then((response) => {
                if (response.data) {
                    //Sandeep:Download option for base 64 received
                    const bytes = atob(response.data);
                    let length = bytes.length;
                    let out = new Uint8Array(length);

                    while (length--) {
                        out[length] = bytes.charCodeAt(length);
                    }

                    const blob = new Blob([out], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);

                    var win = window.open(url, "_blank");
                }
            });
        }
    }

    useEffect(() => {
        getNewsLetter();
    }, [dataState]);

    const handlePageChange = (event) => {
        setDataState({
            skip: event.skip,
            take: event.take,
        });
    };

    return (
        <>
            <Header />
            <PageTitleSection
                title="Trailburner" />
            <div className="container">
                <div className="row d-flex justify-content-center mb-20">
                    <div className="col-lg-12 col-md-12 col-12">
                        <div className="row mb-xl-20">
                            {

                                newsLetter != null && newsLetter.length > 0 ? newsLetter.map((news, i) => {

                                    return <>
                                        {
                                            i == 0 || news.year != newsLetter[i - 1].year ?
                                                <>
                                                    <div>
                                                        <div className="col-md-12"><h3><b>{news.year}</b></h3></div>
                                                    </div>
                                                    <div className="col-md-3 mb-10 news-letter-tile">
                                                        <a onClick={(e) => { saveNewsLetter(e, news.primaryKeyEncrypted, news.isMigrated) }} href={news.file && news.file.fileUrl} target="_blank" style={{ width: '100%' }}>
                                                            <div className="col-md-12 p-5 news-letter-tile-border">
                                                                {/*<div className="col-md-12 text-center">*/}
                                                                {/*    <h3>{news.year}</h3>*/}
                                                                {/*</div>*/}
                                                                <div className="col-md-12 text-center">
                                                                    <b>{news.newsLetterName}</b>
                                                                </div>
                                                                <div className="col-md-12 text-center">
                                                                    <img className="text-center" src={setting.cdnUrl + '/assets/images/newsletter.jpg'} height="80" width="100" />
                                                                </div>
                                                                <div className="col-md-12 text-center">
                                                                    {news.year}
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>

                                                </>
                                                :
                                                <>
                                                    <div className="col-md-3 mb-10 news-letter-tile">
                                                        <a onClick={(e) => { saveNewsLetter(e, news.primaryKeyEncrypted, news.isMigrated) }} href={news.file && news.file.fileUrl} target="_blank" style={{ width: '100%' }}>
                                                            <div className="col-md-12 p-5 news-letter-tile-border">
                                                                {/*<div className="col-md-12 text-center">*/}
                                                                {/*    <h3>{news.year}</h3>*/}
                                                                {/*</div>*/}
                                                                <div className="col-md-12 text-center">
                                                                    <b>{news.newsLetterName}</b>
                                                                </div>
                                                                <div className="col-md-12 text-center">
                                                                    <img className="text-center" src={setting.cdnUrl + '/assets/images/newsletter.jpg'} height="80" width="100" />
                                                                </div>
                                                                <div className="col-md-12 text-center">
                                                                    {news.year}
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </>
                                        }
                                    </>


                                }) : ""
                            }
                        </div>
                    </div>
                    <Pager
                        buttonCount={20}
                        previousNext={true}
                        info={true}
                        total={total}
                        skip={dataState.skip}
                        take={dataState.take}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div >
            <FooterSection />
        </>
    )
}

export default TrailbossBurner;
